import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { ProductListingModel, ProductResponseModel } from 'src/app/models/product/productListing.modal';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-product-listing',
  templateUrl: './product-listing.component.html',
  styleUrls: ['./product-listing.component.css']
})
export class ProductListingComponent implements OnInit {
  productlisting: ProductListingModel;
  productResponseModel: ProductResponseModel;
  pagingModel: PagingModel;
  productlist: any;
  selectedCategory: [];
  getCategories: [];
  Loader: boolean = false;
  totalPages: number;
  pageNumber: number = 1;
  searchValue: string = "";
  filteredCategories: Array<string> = [];

  constructor(private localstorage: LocalstorageService, private _productService: ProductService, private router: Router) {
    this.localstorage.setMenu("5");
    this.productlisting = new ProductListingModel();
    this.productResponseModel = new ProductResponseModel();
    this.pagingModel = new PagingModel();
    this.pagingModel.pageNumber = 1;
    if (this.totalPages == undefined || this.totalPages == 0) {
      this.totalPages = 1;
    }
  }

  ngOnInit() {
    this.getAllCategories();
    this.productListing();
  }

  getAllCategories() {
    this._productService.getCategories().subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.getCategories = responseBody.responseData;
      }
    });
  }

  resetFilter() {
    this.searchValue = "";
    this.filteredCategories = [];
    this.productlisting.PageNumber = 1;
    this.productlisting.PageSize = 10;
    this.totalPages = 1;
    this.pageNumber = 1;
    this.getAllCategories();
    this.productListing();
  }

  filter() {
    this.productlisting.KeyWord = this.searchValue;
    this.productlisting.PageNumber = 1;
    this.productlisting.PageSize = 10;
    this.productlisting.CategoryIds = this.filteredCategories.join(",");
    this.productListing();
  }

  loadPage(pagingModel: PagingModel) {
    this.productlisting.PageNumber = pagingModel.pageNumber;
    this.productlisting.PageSize = pagingModel.pageSize;
    this.productListing();
  }

  productListing() {
    this.Loader = true;
    this.productlisting.CategoryIds = this.filteredCategories.join(",");
    this.productlisting.KeyWord = this.searchValue;
    this._productService.productListing(this.productlisting).subscribe(response => {
      this.Loader = false;
      this.productlist = JSON.parse(response._body);
      if (this.productlist.isSuccess) {
        this.productResponseModel.ProductList = this.productlist.responseData;
        this.productResponseModel.TotalPages = this.productlist.totalPages;
        this.totalPages = this.productResponseModel.TotalPages == undefined ? 0 : this.productResponseModel.TotalPages;
      } (err) => {
        this.Loader = false;
      }
    });
  }

  goToProductEdit(productDetail) {
    this.router.navigate(['/editProduct/' + productDetail.id]);
  }
  viewProductDetails(productDetail) {
    const url = this.router.serializeUrl(
    this.router.createUrlTree(['/product-page/' + productDetail.id]));
    window.open('#' + url, '_blank');
  }
}
